module.exports = __webpack_public_path__ + "static/media/arrow_carousel_grey.6979fb13.svg";